import React from "react";
import axios from "axios";
import { API_URL } from "../config"; // ✅ adjust path if your config is elsewhere

export default function useAuditView({ token, feature_key, payload, action = "REPORT_VIEW" }) {
  React.useEffect(() => {
    if (!token || !feature_key) return;

    const route = window.location.pathname;

    // ✅ StrictMode dev double-mount guard
    // Use sessionStorage so it survives the dev remount cycle
    const key = `audit_view_once:${action}:${feature_key}:${route}`;
    if (sessionStorage.getItem(key) === "1") return;
    sessionStorage.setItem(key, "1");

    axios
      .post(
        `${API_URL}/api/audit/log`,
        {
          action,
          feature_key,
          route_path: route,
          payload: payload || null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .catch(() => {});
  }, [token, feature_key, action]); // payload intentionally not included
}